import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import invoiceAccountRemote from '../../../api/invoiceAccountRemote';

import ResponseError from '../../../models/ResponseError';
import ForwarderAccountAndConfig from '../../../models/ForwarderAccountAndConfig';
import AccountTransaction from '../../../models/AccountTransaction';
import ApiResponse from '../../../models/ApiResponse';

import FwdAccountBalanceDialog from './FwdAccountBalanceDialog';

import { TransferType } from '../../../utils/transferOptions';
import { formatCurrency } from '../../../utils/currencyFormatter';
import validation from '../../../utils/validation';

interface FwdAccountBalanceDialogContainerProps {
  forwarder: ForwarderAccountAndConfig,
  modalOpen: boolean;
  handleCloseModal: () => void;
  loadForwardersAccount: () => void;
  receiveError: Function;
}

interface FwdAccountBalanceDialogContainerState {
  transferType: string,
  sum: string;
  errors: {
    sum: string,
    notes: string
  };
  notes: string,
  firstClick: boolean;
  infoMessage: string;

}
class FwdAccountBalanceDialogContainer extends Component <FwdAccountBalanceDialogContainerProps, FwdAccountBalanceDialogContainerState> {

  state: FwdAccountBalanceDialogContainerState = {
    transferType: TransferType.CREDIT,
    sum: '',
    errors: {
      sum: '',
      notes: ''
    },
    notes: '',
    firstClick: false,
    infoMessage: '',
  };

  handleChange =(field: string, event: any): void => {
    const value: string = event.target.value;
    switch(field) {
      case 'transferType' : this.setState({transferType: value }); break;
      case 'sum' : 
      const isMoneySum: boolean = validation.validateSetMoneySum(value);
      if(isMoneySum || value === '') {
        this.setState({ sum: value});
      }
        break;
      case 'notes' : this.setState({notes: value}); break;
      default :  break;
    }
    this.setState({firstClick: false, infoMessage: ''});
  };

  handleSubmit=() => {
    if (!this.validation() ) {
      return;
    };
    if(!this.state.firstClick) {
      const infoMessage: string = `If you sure want to submit transaction ${this.state.transferType.toLowerCase()} with ${ formatCurrency(parseFloat(this.state.sum), 2, '$')} click SUBMIT button again else correct your data`
      this.setState({firstClick: true, infoMessage});
      return;
    }
    this.setState({firstClick: false});
    const transaction: AccountTransaction = {
       op: this.state.transferType,
       amount: +this.state.sum,
       notes: this.state.notes
    };
    const fwdId: number = this.props.forwarder.id;

    invoiceAccountRemote.setInvoiceAccountTransaction(fwdId, transaction).then((resp: ApiResponse<boolean>) => {
      
      const success: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (success) {
        this.props.handleCloseModal();
        this.props.loadForwardersAccount();
      };

      if (error) {
        this.props.receiveError(error);
      }; 
    });
  };

  validation = (): boolean => {
    const errors = { ...this.state.errors };

    if (!this.state.sum) {
      errors.sum = 'Mandatory Field';
    }
    else if(!this.state.notes) {
      errors.notes = 'you should add notes'
    } else {
      return true;
    }
    this.setState({errors})
    return false;
  };

  handleCloseModal = (): void => {
    this.setEmptyError();
    this.setState({
      firstClick: false,
      infoMessage: '',
      transferType: TransferType.CREDIT,
      sum: '',
      notes: ''
    });
    this.props.handleCloseModal();
  };

  setEmptyError = (): void => {
    const errors = {
      sum: '',
      notes: ''
    };
    this.setState({errors})
  };

  render() {
    return (
      <FwdAccountBalanceDialog 
        forwarder={this.props.forwarder}
        modalOpen={this.props.modalOpen}
        handleChange={this.handleChange}
        handleCloseModal={this.handleCloseModal}
        handleSubmit={this.handleSubmit}
        transferType={this.state.transferType}
        sum={this.state.sum}
        errors={this.state.errors}
        notes={ this.state.notes}
        infoMessage={ this.state.infoMessage }
       />
    )
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
  };
};

export default  connect(null, mapDispatchToProps)(FwdAccountBalanceDialogContainer);